export const AdvisorCaseType = {
    UNKNOWN: 0,
    LIFECASE: 1,
    CONCIERAGECASE: 2,
    ILLUSTRATIONREQUESTCASE: 3
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Constants/CaseType.js